/**
 * TYPES OF POSTS ---------------------------------------------------------------------------------------------------------------
 */

/**
 * Instagram post object (data is retrieved via instagram service)
 * @typedef {{ account: <Account>, analyticsChartFormattedCreatedTime: String, analyticsDetailFormattedCreatedTime: String, caption: String, captionText: String, captionTruncated: String, carouselMediaItems: Array<IgPost>, commentCount: Number, createdMoment: <Moment>, createdtime: Number, displayTime: Number, formattedTimeSinceCreated: String, hasCommentsAndLikes: Boolean, hasLinkinbioPost: Boolean, hasLocation: Boolean, hasMedia: Boolean, hasMoreComments: Boolean, height: Number, highResUrl: String, id: String, igId: String, instagramProfiles: Array<SocialProfile>, isCarouselPost: Boolean, isGraph: Boolean, isImage: Boolean, isLowRes: Boolean, isOwnPost: Boolean, isSelected: Boolean, isVideo: Boolean, likeCount: Number, link: String, lowResUrl: String, manualMatchingFormattedCreatedDate: String, manualMatchingFormattedCreatedTime: String, secureLowBandwitdhVideoUrl: String, secureLowResUrl: String, secureLowResVideoUrl: String, secureStandardResUrl: String, secureStandardResVideoUrl: String, secureThumbUrl: String, socialProfile: <SocialProfile>, standardResUrl: String, tags: Array<String>, thumbUrl: String, timeCollected: Number, type: String, userId, String, userProfileUrl: String, username: String, width: Number, yearMonthFormattedCreatedTime: String }} IgPost

// TODO: finalize once BE is ready
* Instagram reel object
 * @typedef {{ account: <Account>, analyticsChartFormattedCreatedTime: String, analyticsDetailFormattedCreatedTime: String, caption: String, captionText: String, captionTruncated: String, carouselMediaItems: Array<IgReel>, commentCount: Number, createdMoment: <Moment>, createdtime: Number, displayTime: Number, formattedTimeSinceCreated: String, hasCommentsAndLikes: Boolean, hasLinkinbioPost: Boolean, hasLocation: Boolean, hasMedia: Boolean, hasMoreComments: Boolean, height: Number, highResUrl: String, id: String, igId: String, instagramProfiles: Array<SocialProfile>, isCarouselPost: Boolean, isGraph: Boolean, isImage: Boolean, isLowRes: Boolean, isOwnPost: Boolean, isSelected: Boolean, isVideo: Boolean, likeCount: Number, link: String, lowResUrl: String, manualMatchingFormattedCreatedDate: String, manualMatchingFormattedCreatedTime: String, secureLowBandwitdhVideoUrl: String, secureLowResUrl: String, secureLowResVideoUrl: String, secureStandardResUrl: String, secureStandardResVideoUrl: String, secureThumbUrl: String, socialProfile: <SocialProfile>, standardResUrl: String, tags: Array<String>, thumbUrl: String, timeCollected: Number, type: String, userId, String, userProfileUrl: String, username: String, width: Number, yearMonthFormattedCreatedTime: String }} IgReel
 */

/**
 * TikTok post object
 * @typedef {{ commentCount: Number, fullVideoWatchedRate: Number, createdtime: Number, hasMedia: Boolean, id: String, isCarousel: Boolean, isDeleted: Boolean, isTiktokPost: Boolean, likeCount: Number, standardResUrl: String, socialProfile: <SocialProfile>, standardResUrl: String, thumbUrl: String, timeCollected: Number, type: String, videoViews: Number, totalTimeWatched: Number, video_description: String, shareCount: Number, impressions: Number, engagement: Number }} TiktokPost
 */

/**
 * Linkin.bio post object
 * @typedef {{ id: Number, media_id: String, posted_at: Number, shopify_revenue: Number, shopify_revenue_generated: Number }} LIBPost
 */

/**
 * Pinterest pin object
 * @typedef {{ boardId: String, caption: String, clicks: String|Number, commentCount: Number, createdTime: Number, followersCount: Number, id: String, isDeleted: Boolean, link: String, pinnerId: String, repinCount: Number, shortcode: Array<String>, standardResUrl: String, thumbUrl: String, type: String }} Pin
 */

/**
 * Twitter tweet object
 * @typedef {{ clicks: String|Number, created_time: Number, favorite_count: Number, followers_on_post: Number, hashtags: Array<String>, id: String, is_deleted: Boolean, is_multi_photo: Boolean, media_type: String, media_url: String, retweet_count: Number, shortcodes: Array<String>, text: String, tw_media_urls: Array<String>, uid: String, urls: Array<Url> }} Tweet
 */

/**
 * Tiktok post object
 * @typedef {{ timeCollected: Number, hasMedia: Boolean, socialProfile: <SocialProfile>, id: String, createdTime: Number, type: String, isCarousel: Boolean, isDeleted: Boolean, thumbUrl: String, imageUrl: String, engagement: ?Number, impressions: ?Number, reach: ?Number, shareCount: ?Number, videoViews: ?Number, commentCount: !Number, likeCount: !Number, followersCount: !Number, standardResUrl: !String, caption: !String, averageTimeWatched: !Number, totalTimeWatched: !Number, fullVideoWatchedRate: !Number }} TiktokPost
 */

/**
 * TYPES OF USERS ---------------------------------------------------------------------------------------------------------------
 */

/**
 * Instagram user object
 * @typedef {{ followedByCount: Number, followsCount: Number, fullName: String, id: String, mediaCount: Number, secureProfilePictureUrl: String, username: String, website: String }} IgUser
 */

/**
 * IG OBJECTS -------------------------------------------------------------------------------------------------------------------
 */

/**
 * Data point for Instagram page views over time graph
 * @typedef {{ time: Number, profile_views: Number }} IGPageView
 */

/**
 * Data point for Instagram page clicks over time graph
 * @typedef {{ time: Number, website_clicks: Number }} IGPageClick
 */

/**
 * Data point for Instagram impressions over time graph
 * @typedef {{ time: Number, impressions: Number }} IGImpression
 */

/**
 * Data point for Instagram reach over time graph
 * @typedef {{ time: Number, reach: Number }} IGReach
 */

/**
 * Data point for Instagram follower count over time graph
 * @typedef {{ time: Number, followers: Number }} IGFollowerCount
 */

/**
 * Data point for Instagram media count over time
 * @typedef {{ time: Number, media_count: Number }} IGMediaCount
 */

/**
 * Data point for Instagram following count over time
 * @typedef {{ time: Number, follows_count: Number }} IGFollowingCount
 */

/**
 *
 * @typedef {{mediaCount: Number|String, followedByCount: Number|String, followsCount: Number|String}} IGProfileCount
 */

/**
 * TikTok Objects -------------------------------------------------------------------------------------------------------------------
 */

/**
 * Data point for TikTok profile views count over time graph
 * @typedef {{ time: Number, profile_views: Number }} TiktokProfileViewsCount
 */

/**
 * Data point for TikTok video views count over time graph
 * @typedef {{ time: Number, video_views: Number }} TiktokVideoViewsCount
 */

/**
 * LIB OBJECTS ------------------------------------------------------------------------------------------------------------------
 */

/**
 * Data point for Linkin.bio page views over time
 * @typedef {{ time: Number, value: Number }} LIBButtonClick
 */

/**
 * Data point for Linkin.bio page views over time
 * @typedef {{ time: Number, value: Number }} LIBPageView
 */

/**
 * Linkin.bio clicks over time dataset
 * @typedef {{ time: Number, value: Array<LIBClickPoint> }} LIBClicksOverTime
 */

/**
 * Data point for Linkin.bio clicks over time graph
 * @typedef {{ linkinbio_post.id: Number, result: Number, media.id: String }} LIBClickPoint
 */

/**
 * MEDIA OBJECTS ----------------------------------------------------------------------------------------------------------------
 */

/**
 * Generic data point for media
 * @typedef {{ sampled_at: Number, count: Number }} MediaGenericDataPoint
 */

/**
 * AUDIENCE ANALYTICS OBJECTS ---------------------------------------------------------------------------------------------------
 */

/**
 * Data point for media gender and age
 * @typedef {{ time: Number, audienceGenderAge: any }} GenderAgeDataPoint
 */

/**
 * Data point for media gender
 * @typedef {{ time: Number, audienceGender: any }} GenderDataPoint
 */

/**
 * Data point for media followers online at given time
 * @typedef {{ time: Number, day: Number, onlineFollowersMap: Array<Number> }} FollowerOnlinePoint
 */

/**
 * Data point for country/city of Linkin.bio page view, total Linkin.bio page view count, and percentage of total page views
 * @typedef {{ title: String, value: String, percent: String }} GeographicPoint
 */

/**
 * Array of countries and counts, the "country_code" key is dynamic (ex. 'CA', 'AU', etc...)
 * @typedef {{ [country_code: String]: String }} CountryResponse
 */

/**
 * Array of cities and counts, the "city_code" key is dynamic (ex. 'Toronto, Ontario', 'Hong Kong, Hong Kong', etc...)
 * @typedef {{ [city_code: String]: String }} CityResponse
 */

/**
 * Array of languages and counts, the "locale_code" key is dynamic (ex. 'fr_CA', 'en_AU', etc...)
 * @typedef {{ [locale_code: String]: String }} LocaleResponse
 */

/**
 * MISC OBJECTS -----------------------------------------------------------------------------------------------------------------
 */

/**
 * Url object
 * @typedef {{ expanded_url: String, display_url: String, indicies: Array<String>, url: String }} Url
 */

/**
 * Meta object
 * @typedef {{ first_data_point: Number }} Meta
 */

/**
 * Array of hashtag trends graph data points, the "name" key is dynamic (ex. 'apple', 'coding', etc...)
 * @typedef {{ [Name: String]: Array<FormattedHashtagTrendsDataPoint> }} FormattedHashtagTrends
 */

/**
 * Hashtag trends graph data point
 * @typedef {{ startTime: Number, endTime: Number, numberOfPosts: Number, totalPosts: Number, percentagePosts: Number }} FormattedHashtagTrendsDataPoint
 */

/**
 * Errors ------------------------------------------------------------------------------------------------------------------------
 */

/**
 * Format of an anlytics error object
 * @typedef {{error: { errorText: string, errorType: String }}} AnalyticsError
 */
define("settings/types/typedef", [], function () {
  "use strict";
});